import React from 'react'
import './desc.css'
const Desc = () => {
  return (
    <div className='Desc'>
      
      <div className="ListSection">
        <div className="ListSectionColumn1">
            <img src="https://www.pixel-industry.com/html/musician/musician-html/img/pics/music-album-artist.jpg" alt="" />
            <div>
            <span><a href="">STORE</a>|</span>
            <span><a href="">ITUNES</a>|</span>
            <span><a href="">LISTEN</a></span>
            </div>
        </div>
        <div className="ListSectionColumn2">
            <div className="ListSectionColumn2Date">RELEASED MAR 23, 2016</div>
            <div className="ListSectionColumn2Heading"><a href="">Live from London</a> </div>
            <div className="ListSectionColumn2Items">
            <span>1. Rock It</span>
            <span>2. Faking Freedom</span>
            <span>3. Rock Will Find A Way</span>
            <span>4. Did I Mention Democracy</span>
            <span>5. Hysterics Connection</span>
            <span>6. Waiting For Remorse</span>
            <span>7. Hotshot Space</span>
            <span>8. Jealous Of My Spotlight</span>
            <span>9. Friendly Patience</span>
            <span>10. When It Comes to Diversity</span>
         </div>
            
        </div>

      </div>

      <div className="DescLine" ></div>

      <div className="DescText">
        <p className='DescTextPara1'>
        Although the band broken up a few times now, they released a new album “Please be honest”. What is so strange about this new album. Well, for start, main man Robert Pollard is playing all the instruments. You may ask yourself why this isn’t his album then? Good question indeed.

        </p>
        <p className='DescTextPara2'>

        Swag XOXO sustainable, waistcoat tacos kickstarter letterpress listicle YOLO polaroid pug. Gluten-free swag small batch brooklyn meditation, normcore put a bird on it listicle. Banjo pabst meggings, mustache knausgaard wolf you probably haven't heard of them organic flexitarian fingerstache health goth gluten-free occupy tousled. Cronut waistcoat cred, church-key mustache retro wolf ramps tilde mlkshk neutra actually. Tattooed irony gochujang, plaid kinfolk celiac crucifix fingerstache poutine four dollar toast cronut. Tousled man braid freegan, austin kitsch asymmetrical hella +1 vegan try-hard meditation bespoke keffiyeh banjo. Chillwave 90's chia, pork belly pinterest pour-over chartreuse locavore vegan synth trust fund.
        </p>
      </div>
    </div>
  )
}

export default Desc
